import { useContext, useState } from "react"
import { DropDown, Input, DateControl } from '../components'
import { catTypeDocument } from '../data/MochaData'
import { DataContext } from "../data/DataContext"
import { CalculateAge } from '../../../utils/helpMain'

const StepPersonalData: React.FC = () => {
    const { IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 } = useContext(DataContext);
    const onChangeDate = (property: string, value: any) => {
        const ageCal = CalculateAge(value);
        SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, [property]: value, age: ageCal })
    }

    return (<>
        <DropDown
            dataProvider={catTypeDocument}
            field='identificationType'
            label='Tipo de identificación'
            valueSelect={IHContenidoSeguroCR.identificationType}
            onChangeSelect={ChangeHandler2}
        />
        <Input
            id="identification"
            label="Número de identificación"
            value={IHContenidoSeguroCR.identification}
            field="identification"
            onChange={ChangeHandler}
            type={IHContenidoSeguroCR.identificationType === '1' ? 'mask' : undefined}
            mask={IHContenidoSeguroCR.identificationType === '1' ? "9-9999-9999" : undefined}
            pattern={IHContenidoSeguroCR.identificationType === '1' ? "\\d-\\d\\d\\d\\d-\\d\\d\\d\\d" : undefined}
            title={IHContenidoSeguroCR.identificationType === '1' ? "Documento invalido" : undefined}
        />
        <Input
            field='firstName1'
            id='firstName1'
            label='Nombres'
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.firstName1}
        />
        <Input
            field='firstName2'
            id='firstName2'
            label=''
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.firstName2}
            isRequired={false}
        />
        <Input
            field='lastName1'
            id='lastName1'
            label='Apellidos'
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.lastName1}
            isRequired={false}
        />
        <Input
            field='lastName2'
            id='lastName2'
            label=''
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.lastName2}
            isRequired={false}
        />
        <DateControl
            id='birthdate'
            label='Fecha de nacimiento'
            onChange={onChangeDate}
            value={IHContenidoSeguroCR.birthdate}
            maxDate={new Date()}
        />
        <Input
            field='age'
            id='age'
            label='Edad'
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.age}
        />
        <Input
            id='phoneNumber'
            label='Número de Celular'
            field='phoneNumber'
            value={IHContenidoSeguroCR.phoneNumber}
            onChange={ChangeHandler}
            placeholder='0000-0000'
            type='mask'
            mask="9999-9999"
            title="Documento invalido"
        />
        <Input
            label='Correo electrónico'
            value={IHContenidoSeguroCR.mail}
            onChange={ChangeHandler}
            field='mail'
            id='mail'
        />
    </>)
}

export { StepPersonalData };